import { useMutation } from '@apollo/client';

import { CreateBedroomTransactionInput } from '../../apollo/__generated__/graphql';
import { CREATE_BEDROOM_TRANSACTION } from '../graphql/mutations/createBedroomTransactionMutation.graphql';

export const useCreateBedroomTransactionMutation = () => {
  const [mutate] = useMutation(CREATE_BEDROOM_TRANSACTION, {
    onCompleted: (data) => {
      window.location.href = data.createBedroomTransaction;
    },
  });

  const createBedroomTransaction = (
    createBedroomTransactionInput: CreateBedroomTransactionInput,
  ) =>
    mutate({
      variables: {
        createBedroomTransactionInput,
      },
    });

  return { createBedroomTransaction };
};
